var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0691 28.35C27.8391 26.96 29.3191 26.14 30.1791 24.91C31.0891 23.62 30.5791 21.21 27.9991 21.21C26.3091 21.21 25.4791 22.49 25.1291 23.55L22.5391 22.46C23.2491 20.33 25.1791 18.5 27.9891 18.5C30.3391 18.5 31.9491 19.57 32.7691 20.91C33.4691 22.06 33.8791 24.21 32.7991 25.81C31.5991 27.58 30.4491 28.12 29.8291 29.26C29.5791 29.72 29.4791 30.02 29.4791 31.5H26.5891C26.5791 30.72 26.4591 29.45 27.0691 28.35ZM29.9991 35.5C29.9991 36.6 29.0991 37.5 27.9991 37.5C26.8991 37.5 25.9991 36.6 25.9991 35.5C25.9991 34.4 26.8991 33.5 27.9991 33.5C29.0991 33.5 29.9991 34.4 29.9991 35.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedQuestion);
export default __webpack_public_path__ + "static/media/selected-question.2592c8132e1f419b07e7ea61987fdfb1.svg";
export { ForwardRef as ReactComponent };